import { Dispatch, SetStateAction, useState } from 'react';

export default function useToggleable(initialIsOpen?: boolean): [
  boolean,
  {
    handleOpen: () => void;
    handleClose: () => void;
    handleToggle: () => void;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
  }
] {
  const [isOpen, setState] = useState(!!initialIsOpen);

  return [
    isOpen,
    {
      handleOpen: () => setState(true),
      handleClose: () => setState(false),
      handleToggle: () => setState(state => !state),
      setIsOpen: setState
    }
  ];
}
